import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/** Stolen and slightly modified from material-ui 🙃 */
import React, { memo } from 'react';
import { useTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

function createSvgIcon(path, displayName) {
  let Icon = _ref => {
    let {
      fill = 'inherit',
      stroke: passedStroke,
      style = []
    } = _ref,
        props = _objectWithoutProperties(_ref, ["fill", "stroke", "style"]);

    const theme = useTheme();
    const stroke = passedStroke || theme.props.iconStroke || '#1f67af';
    return /*#__PURE__*/React.createElement(SvgIcon, _extends({
      style: _objectSpread({
        color: fill
      }, style)
    }, props), path(stroke));
  };

  Icon.displayName = `${displayName}Icon`;
  Icon = /*#__PURE__*/memo(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

export default createSvgIcon;